import React from "react"
import Icon from "../Icon"
import { theme } from "twin.macro"

export default function Empty({ description, height }) {
    return (
        <div tw="center flex-col" style={{ height }}>
            <Icon name="empty" size={80} />
            <span tw="text-text_body" css={[theme`typo.mregular`]}>
                {description}
            </span>
        </div>
    )
}

export const renderEmpty = (props) => {
    return function builder(componentName) {
        if (componentName === "Table.filter") {
            return <Empty {...props} />
        }
    }
}
